export default __webpack_public_path__ + "static/media/areatoraise-Five.4750755e.jpg";